<template>
    <component
            :is="getUserStatsLayout"
            :coursesVisibility="coursesVisibility"
            :hoursVisibility="hoursVisibility"
            :postsVisibility="postsVisibility"
            :certificatesVisibility="certificatesVisibility"
            :messagesVisibility="messagesVisibility"
            :userStats="userStatsData"
            @navigate-to-inbox="navigateToInbox"
    ></component>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import AnimationsMixin from "../../../author/pagesbuilder/mixins/AnimationsMixin";
    import UserStatsLayout1 from "../../../author/pagesbuilder/templates/cards/UserStatsLayout1";
    import UserStatsLayout2 from "../../../author/pagesbuilder/templates/cards/UserStatsLayout2";

    export default {
        name: "UserStatsComponent",
        mixins: [
            AnimationsMixin
        ],
        data () {
            return {
                componentType: "userStats",
                rendersWithVue: true,
            }
        },
        computed:{
            ...mapState('user', [
                'stats',
                'unreadInboxMessages'
            ]),
            availableUserStatsTemplates () {
                return [
                    {
                        templateFilename : "UserStatsLayout1",
                        forSectionTemplates: [
                            "tpl129",
                        ],
                    },
                    {
                        templateFilename : "UserStatsLayout2",
                        forSectionTemplates: [
                            "tpl152",
                        ],
                    },
                ];
            },
            userStatsData () {
                return {
                    courseCount: this.courseCount,
                    learningHours: this.learningHours,
                    postsCount: this.postsCount,
                    certificatesCount: this.certificatesCount,
                    messageCount: this.messageCount,
                }
            },
            getUserStatsLayout () {
                let sectionState = this.findNodeState(this.sectionId);
                if (sectionState) {
                    let sectionTemplateId = sectionState.sectionTemplateId;
                    let userStatsTemplate = this.availableUserStatsTemplates.find(template => template.forSectionTemplates.includes(sectionTemplateId));
                    return userStatsTemplate?.templateFilename;
                }

                return null;
            },
            courseCount(){
                return (this.stats && this.stats.courses)? this.stats.courses : 0;
            },
            learningHours(){
                return (this.stats && this.stats.hours)? this.stats.hours : 0;
            },
            postsCount(){
                return  (this.stats && this.stats.posts)? this.stats.posts : 0;
            },
            certificatesCount(){
                return  (this.stats && this.stats.certificates)? this.stats.certificates : 0;
            },
            messageCount(){
                return this.unreadInboxMessages;
            },        
            coursesVisibility(){
                return this.myData.coursesVisibility
            },
            hoursVisibility(){
                return this.myData.hoursVisibility
            },
            postsVisibility(){
                return this.myData.postsVisibility
            },
            certificatesVisibility(){
                return this.myData.certificatesVisibility
            },
            messagesVisibility(){
                return this.myData.messagesVisibility
            },
            getDefaultDataStructure () {
                return {
                    componentType: this.componentType,
                    componentId: this.componentId,
                    coursesVisibility: true,
                    hoursVisibility: true,
                    postsVisibility: true,
                    certificatesVisibility: true,
                    messagesVisibility: true,
                    itemVisibilitySettings: null
                }
            },        
        },
        mounted(){
            this.getUserStats();
        },
        methods: {
            ...mapActions('user', [
                'getUserStats'
            ]),
            navigateToInbox(){

            }
        },
        components: {
            UserStatsLayout1,
            UserStatsLayout2,
        }
    }
</script>
